import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from "../layout/Header";

const Signup = () => {
const [userSectioon, setUserSection] = useState(true);
  const [errors, setErrors] = useState({});
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const navigate = useNavigate();

  const referralCode = localStorage.getItem('referral_code');
  const agentCode = localStorage.getItem('agent_code');
  const affiliateCode = localStorage.getItem('affiliate_code');

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    session_id: 1,
    confirmPassword: '',
    name: '',
    phone: '',
    email: '',
    dofb: '2002-01-01',
    referral_code: '',
    agent_code: agentCode || '',
    currency: 'BDT',
    status: 'active',
    legal_age: true,
  });

  useEffect(() => {
    if (referralCode) {
      setFormData((prev) => ({ ...prev, referral_code: referralCode }));
    } else {
      setFormData((prev) => ({ ...prev, referral_code: affiliateCode }));
    }
  }, [referralCode, affiliateCode]);

  const togglePasswordVisibility = () => setPasswordShown(!passwordShown);
  const toggleConfirmPasswordVisibility = () =>
    setConfirmPasswordShown(!confirmPasswordShown);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUserSection = () => {
    if (userSectioon) {
      const step1Errors = {};

      if (!formData.username)
        step1Errors.username = "Username is required";
      else if (!/^[a-zA-Z0-9]+$/.test(formData.username))
        step1Errors.username = "Invalid username (only letters and numbers)";
      else if (formData.username.length < 8 || formData.username.length > 16)
        step1Errors.username = "Username must be between 8 and 16 characters";

      if (!formData.password)
        step1Errors.password = "Password is required";
      else if (!/^\d{1,6}$/.test(formData.password))
        step1Errors.password = "Password must be 1-6 digits (numbers only)";

      if (!formData.confirmPassword)
        step1Errors.confirmPassword = "Confirm Password is required";
      else if (formData.confirmPassword !== formData.password)
        step1Errors.confirmPassword = "Passwords do not match";

      setErrors(step1Errors);
      if (Object.keys(step1Errors).length > 0) return;
      setUserSection(false);
    } else {
      setUserSection(true);
    }
  };

  const validate = () => {
    const tempErrors = {};
    const usernamePattern = /^[a-zA-Z0-9]+$/;
    const phonePattern = /^[0-9]{10,15}$/;
    const passwordPattern = /^\d{1,6}$/; // 1-6 digits only, no other rules

    if (!formData.username)
      tempErrors.username = "Username is required";
    else if (!usernamePattern.test(formData.username))
      tempErrors.username = "Invalid username (only letters and numbers)";
    else if (formData.username.length < 8 || formData.username.length > 16)
      tempErrors.username = "Username must be between 8 and 16 characters";

    if (!formData.password)
      tempErrors.password = "Password is required";
    else if (!passwordPattern.test(formData.password))
      tempErrors.password = "Password must be 1-6 digits (numbers only)";

    if (!formData.confirmPassword)
      tempErrors.confirmPassword = "Confirm Password is required";
    else if (formData.confirmPassword !== formData.password)
      tempErrors.confirmPassword = "Passwords do not match";

    if (!formData.phone)
      tempErrors.phone = "Phone number is required";
    else if (!phonePattern.test(formData.phone))
      tempErrors.phone = "Invalid phone number (10-15 digits)";

    if (!formData.legal_age) {
      tempErrors.legal_age = "You must be of legal age to register";
    }

    setErrors(tempErrors);
    return tempErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Track signup button click via GTM dataLayer
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'signup_button_click' });
    }

    const validationErrors = validate();
    const hasErrors = Object.keys(validationErrors).length > 0;
    if (hasErrors) {
      // Decide which section to show based on where the errors are
      const step1Fields = ['username', 'password', 'confirmPassword'];
      const step1HasError = step1Fields.some(f => validationErrors[f]);
      setUserSection(step1HasError); // show step1 if its fields invalid otherwise stay on step2
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-players`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Origin': window.location.origin,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        // ✅ Auto login after signup
        const loginResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: formData.username,
            password: formData.password,
          }),
        });

        const loginData = await loginResponse.json();
        if (loginResponse.ok) {
          localStorage.setItem('token', loginData.token);
          localStorage.setItem('remote_id', loginData.remote_id);
          localStorage.setItem('username', loginData.username);

          if (data.exchange?.[0]?.token)
            localStorage.setItem('exchangeToken', data.exchange[0].token);
          else
            localStorage.removeItem('exchangeToken');

          localStorage.setItem('popup', 1);
          localStorage.setItem('regPopup', 1);
          localStorage.removeItem('agent_code');
          localStorage.removeItem('referral_code');
          localStorage.removeItem('affiliate_code');

          window.location.href = '/';
        } else {
          setErrors({ general: loginData.message });
        }
      } else {
        let msg = data?.message || "Submission failed";
        console.log(data?.message, "Submission failed")
        setErrors(data.errors || { general: msg });

        if (data.errors?.username) {
          setUserSection(true);
        }
      }
    } catch (error) {
      console.error("Error during signup:", error);
      setErrors({ general: "Network error, please try again" });
      setUserSection(true);
    }
  };

  return (
   <div className="v-application--wrap">
  <div>
    <div className="row no-gutters">
      <Header/>
    </div>
    
  
    <div className="body">
      <div className="full-width" openlogindialog="function(){}">
        <div className="col col-12 px-2 register_panel">
          { (errors.general || Object.keys(errors).length > 0) && (
            <div className="error-popup" style={{background:'#400',color:'#fff',padding:'8px',borderRadius:'4px',marginBottom:'12px'}}>
              {errors.general ? errors.general : 'Please fix the highlighted errors.'}
            </div>
          )}
          <div className="row hidden-md-and-up">
            <div className="mobile-header text-center col col-12">
              Register now
            </div>
            <div className="pa-0 col col-12">
              <div className="v-image v-responsive theme--dark">
                <div className="v-responsive__sizer" style={{paddingBottom: '28.875%'}} />
                <div className="v-image__image v-image__image--cover" style={{backgroundImage: 'url("./static/image/banner/registerBanner/register_banner_en.jpg")', backgroundPosition: 'center center'}} />
                <div className="v-responsive__content" style={{width: '800px'}} />
              </div>
            </div>
          </div>
          <div className="row hidden-sm-and-down mt-2" style={{margin: 'unset'}}>
            <div className="login-header text-center py-0 col col-12">
              Create Account
            </div>
            <div className="login-header-desc text-center pt-0 col col-12">
              Let’s get you registered on the No.1 Cricket Exchange &amp; Betting Platform
            </div>
          </div>
          <div className="row hidden-md-and-up no-gutters">
            <div className="mt-5 pt-3 text-center col col-12">
              <div className="text-center d-inline-flex v-item-group theme--dark">
                <div className="mx-auto itemDiv">
                  <button type="button" className="mobile-resgiter-dialog-pagination v-btn mobile-resgiter-dialog-pagination-active v-btn--active v-btn--icon v-btn--round theme--dark v-size--default" style={{height: '30px', width: '30px'}}>
                    <span className="v-btn__content">
                      1
                    </span>
                  </button>
                </div>
                <div className="mx-auto itemDiv lastItemDiv">
                  <button type="button" className="mobile-resgiter-dialog-pagination v-btn v-btn--icon v-btn--round theme--dark v-size--default" style={{height: '30px', width: '30px'}}>
                    <span className="v-btn__content">
                      2
                    </span>
                  </button>
                </div>
                <div className="itemDiv">
                  <button type="button" className="mobile-resgiter-dialog-pagination v-btn v-btn--icon v-btn--round theme--dark v-size--default" style={{height: '30px', width: '30px'}}>
                    <span className="v-btn__content"><i aria-hidden="true" className="v-icon notranslate material-icons theme--dark" style={{width: '30px', height: '30px', fontSize: '30px'}}>check_circle_outline</i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
         
          <div className="row justify-center hidden-md-and-up">
            <div className="col col-12">
              <div className="v-window v-item-group theme--dark ma-8">
                <div className="v-window__container">
                 {userSectioon ? (
                     <div className="v-window-item v-window-item--active">
                    <form noValidate="novalidate" className="v-form">
                      <div className="row justify-center">
                        <div className="col-md-8 col-12">
                          <div className="v-card__text ma-0 pa-0">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Username<span className="red--text ml-1">*</span></label>
                                </div>
                                <div className="col col-2">
                                  <i aria-hidden="true" aria-haspopup="true" aria-expanded="false" className="v-icon notranslate material-icons theme--dark primary--text" style={{float: 'right'}}>help</i>
                                  <span className="v-tooltip v-tooltip--right">{/**/}</span>
                                </div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                              name="username"
                                              type="text"
                                              className="input ng-untouched ng-pristine ng-invalid"
                                              placeholder="8-16 char, allow number & letter"
                                              value={formData.username}
                                              onChange={handleChange}
                                          />
                                          </div>
                                      </div>
                                      {errors.username &&
                                      <div class="v-text-field__details">
                                          <div class="v-messages theme--dark error--text" role="alert">
                                              <div class="v-messages__wrapper"><div class="v-messages__message">{errors.username}</div></div>
                                          </div>
                                      </div>
                                        }
                                    </div>
                                  </div>
                                 
                                </div>
                              </div>
                            </div>
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Password<span className="red--text ml-1">*</span></label>
                                </div>
                                <div className="col col-2">
                                  <i aria-hidden="true" aria-haspopup="true" aria-expanded="false" className="v-icon notranslate material-icons theme--dark primary--text" style={{float: 'right'}}>help</i>
                                  <span className="v-tooltip v-tooltip--right">{/**/}</span>
                                </div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            name="password"
                                            type={passwordShown ? "text" : "password"}
                                            placeholder="1-6 digits"
                                            value={formData.password}
                                            onChange={handleChange}
                                            inputMode="numeric"
                                            maxLength={6}
                                            pattern="[0-9]*"
                                        />
                                          </div>
                                        <div className="v-input__append-inner"><button type="button" onClick={togglePasswordVisibility} className={`v-icon notranslate v-icon--link mdi ${
                                              passwordShown ? 'mdi-eye-off' : 'mdi-eye'
                                            } theme--dark`} /></div>
                                      </div>
                                      {errors.password &&
                                      <div class="v-text-field__details">
                                          <div class="v-messages theme--dark error--text" role="alert">
                                              <div class="v-messages__wrapper"><div class="v-messages__message">{errors.password}</div></div>
                                          </div>
                                      </div>
                                        }
                                    </div>
                                  </div>
                                  {/**/}{/**/}
                                </div>
                              </div>
                            </div>
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Confirm Password<span className="red--text ml-1">*</span></label>
                                </div>
                                <div className="col col-2">{/**/}</div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            name="confirmPassword"
                                            type={confirmPasswordShown ? "text" : "password"}
                                            className="input ng-untouched ng-pristine ng-invalid"
                                            placeholder="1-6 digits"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            inputMode="numeric"
                                            maxLength={6}
                                            pattern="[0-9]*"
                                                />
                                          </div>
                                        <div className="v-input__append-inner"><button type="button" onClick={toggleConfirmPasswordVisibility} className={`v-icon notranslate v-icon--link mdi ${
                                              confirmPasswordShown ? 'mdi-eye-off' : 'mdi-eye'
                                            } theme--dark`} /></div>
                                      </div>
                                     {errors.confirmPassword &&
                                      <div class="v-text-field__details">
                                          <div class="v-messages theme--dark error--text" role="alert">
                                              <div class="v-messages__wrapper"><div class="v-messages__message">{errors.confirmPassword}</div></div>
                                          </div>
                                      </div>
                                        }
                                    </div>
                                  </div>
                                  {/**/}{/**/}
                                </div>
                              </div>
                            </div>
                            <div className="pa-0 col-md-10 col-12">
                              <div className="v-card__text ma-0 pa-0">
                                <label className="input-field-label ma-0 pb-1 text-capitalize d-block">
                                  Currency
                                  <span className="red--text ml-1">*</span>
                                </label>
                                <div className="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select">
                                  <div className="v-input__prepend-outer">
                                    <div className="v-input__icon v-input__icon--prepend">
                                      <span aria-hidden="true" className="v-icon notranslate theme--dark">
                                        <svg width={20} height={18} id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve" className="v-icon__component theme--dark">
                                          <g>
                                            <circle cx={50} cy={50} r={45} className="st0" />
                                            <path d="M47.1,78.5c-15.4,0-27.9-12.5-27.9-27.9c0-15.4,12.5-27.8,27.9-27.8C62.6,22.8,75,35.3,75,50.7
		C75,66,62.5,78.5,47.1,78.5z" className="st1" />
                                            <path d="M50,5C25.1,5,5,25.1,5,50s20.1,45,45,45s45-20.1,45-45S74.9,5,50,5z M50,93C26.3,93,7,73.7,7,50S26.3,7,50,7
		s43,19.3,43,43S73.7,93,50,93z" className="st2" />
                                          </g>
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="v-input__control">
                                    <div role="button" aria-haspopup="listbox" aria-expanded="false" aria-owns="list-480" className="v-input__slot">
                                      <fieldset aria-hidden="true">
                                        <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                      </fieldset>
                                      <div className="v-select__slot">
                                        <div className="v-select__selections">
                                          <div className="v-select__selection v-select__selection--comma"></div>
                                          <input id="input-480" readOnly="readonly" type="text" aria-readonly="false" autoComplete="off"
                                            name="currency"
                                            defaultValue={'BDT'}
                                           value={formData.currency}
                                                        onChange={handleChange}
                                          />
                                        </div>
                                        <div className="v-input__append-inner">
                                          <div className="v-input__icon v-input__icon--append"><i aria-hidden="true" className="v-icon notranslate mdi mdi-menu-down theme--dark" /></div>
                                        </div>
                                        <input type="hidden" defaultValue="BDT" />
                                      </div>
                                      <div className="v-menu">{/**/}</div>
                                    </div>
                                    <div className="v-text-field__details">
                                      <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-center no-gutters">
                        <div className="col col-12">
                          <button onClick={handleUserSection} data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 dialog-button hidden-md-and-up v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1 mobile-next-btn">
                            <span className="v-btn__content">Next </span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                 ):(
                    <div  className="v-window-item v-window-item--active">
                    <form noValidate="novalidate" className="v-form">
                      {/**/}
                      <div className="v-card__text ma-0 pa-0">
                        <div className="mobile">
                        </div>
                        <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                          Phone Number
                          <span className="red--text ml-1">*</span>
                        </label>
                        <div className="row no-gutters">
                          <div className="col col-5">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">{/**/}</div>
                                <div className="col col-2">{/**/}</div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder mr-2 reg-mobile-prefix">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input autoComplete="new-password" disabled value={'+88'}  id="input-499" placeholder={+880} type="text" />
                                        </div>
                                      </div>
                                      <div className="v-text-field__details">
                                        <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                                      </div>
                                    </div>
                                  </div>
                                  {/**/}{/**/}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col col-7">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">{/**/}</div>
                                <div className="col col-2">{/**/}</div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                                        name="phone"
                                                        type="text"
                                                        className="input ng-untouched ng-pristine ng-invalid"
                                                        placeholder="Phone Number"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                    />
                                          </div>
                                      </div>
                                      {errors.phone && (
                                        <div className="v-text-field__details">
                                          <div className="v-messages theme--dark error--text" role="alert">
                                            <div className="v-messages__wrapper">
                                              <div className="v-messages__message">{errors.phone}</div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {/**/}{/**/}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row no-gutters">
                          <div className="col col-12">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Referral Code{/**/}</label>
                                </div>
                                <div className="col col-2">{/**/}</div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                                        name="referral_code"
                                                        type="text"
                                                        className="input ng-untouched ng-pristine ng-valid"
                                                        placeholder="Enter if you have one"
                                                        value={formData.referral_code}
                                                        readOnly={!!formData.agent_code}
                                                        onChange={handleChange}
                                                    />
                                                     <input
                                                        name="agent_code"
                                                        type="hidden"
                                                        value={formData.agent_code}    
                                                    />
                                          </div>
                                      </div>
                                      <div className="v-text-field__details">
                                        <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                                      </div>
                                    </div>
                                  </div>
                                  {/**/}{/**/}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row no-gutters">
                          <div className="col col-12">
                            <div className="v-input mt-0 pt-0 theme--dark v-input--selection-controls v-input--checkbox">
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <div className="v-input--selection-controls__input">
                                    <i aria-hidden="true" className="v-icon notranslate mdi mdi-checkbox-marked theme--dark" />
                                    <input
                                      id="input-510"
                                      role="checkbox"
                                      type="checkbox"
                                      checked={true}
                                      readOnly
                                      name="legal_age"
                                    />
                                    <div className="v-input--selection-controls__ripple" />
                                  </div>
                                  <label htmlFor="input-510" className="v-label theme--dark" style={{left: '0px', right: 'auto', position: 'relative'}}>
                                    <p className="caption pt-2 mb-0">
                                      <label>I am of legal age and i agree with the </label>
                                      <label className="text-decoration-underline font-weight-bold" style={{cursor: 'pointer'}}>Terms and Conditions.</label>
                                    </p>
                                  </label>
                                </div>
                                <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {errors.legal_age && (
                          <div className="row no-gutters">
                            <div className="col col-12">
                              <div className="error--text subtitle-2">{errors.legal_age}</div>
                            </div>
                          </div>
                        )}
                          <div className="col col-7">
                          <div className="col col-12">
                            <button onClick={handleSubmit} data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 dialog-button v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1 mobile-next-btn">
                              <span className="v-btn__content">Complete Registration </span>
                            </button>
                          </div>
                          <div className="text-center col col-12"><label className="red--text subtitle-2" style={{display: 'none'}} /><label className="red--text subtitle-2" style={{display: 'none'}} /></div>
                        </div>
                      </div>
                    </form>
                  </div>
                 )}
                  
                  {/**/}{/**/}
                </div>
              </div>
            </div>
          </div>
          {/**/}
        </div>
        <div data-v-c5353408 role="dialog" className="v-dialog__container">{/**/}</div>
      </div>
    </div>
  </div>
</div>
  );
};

export default Signup;